<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeSlug: {
    type: String,
    default: '',
  },
  showRemove: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['remove', 'select']);

const buildLabel = item => item?.label || item?.slug || 'Busca salva';
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="contents">
    <section
      v-if="items.length"
      class="rounded-lais border border-lais-border-soft bg-white px-4 py-3 shadow-lais-card"
    >
      <div class="mb-3 flex items-center justify-between gap-3">
        <div>
          <p
            class="text-[12px] font-semibold uppercase tracking-wide text-lais-text-muted"
          >
            Buscas recentes
          </p>
          <p class="text-[13px] text-lais-text-helper">
            Reaplique filtros salvos para o cliente em um clique.
          </p>
        </div>
        <span
          class="inline-flex min-w-8 justify-center rounded-full bg-lais-primary-50 px-2 py-1 text-[11px] font-semibold text-lais-primary"
        >
          {{ items.length }}
        </span>
      </div>

      <div class="flex flex-wrap gap-2">
        <div
          v-for="item in items"
          :key="item.id"
          class="inline-flex max-w-full items-center gap-1.5"
        >
          <button
            type="button"
            class="inline-flex max-w-full items-center gap-2 rounded-full border px-3 py-2 text-left text-[12px] transition-colors"
            :class="
              activeSlug && item.slug === activeSlug
                ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
                : 'border-lais-border bg-white text-lais-text hover:border-lais-primary hover:bg-lais-primary-50/40'
            "
            @click="$emit('select', item)"
          >
            <span
              class="i-lucide-search size-3.5 shrink-0"
              aria-hidden="true"
            />
            <span class="truncate">{{ buildLabel(item) }}</span>
            <span
              v-if="item.accessCount || item.access_count"
              class="rounded-full bg-black/5 px-1.5 py-0.5 text-[10px] font-semibold"
            >
              {{ item.accessCount || item.access_count }}x
            </span>
          </button>
          <button
            v-if="showRemove"
            type="button"
            class="grid size-7 place-items-center rounded-full text-lais-text-muted transition-colors hover:bg-lais-primary-50 hover:text-lais-primary"
            aria-label="Remover busca recente"
            @click="$emit('remove', item)"
          >
            <span class="i-lucide-x size-3.5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
